import Link from 'next/link';
import React from 'react';

import classNames from 'classnames';

import UIResource from '@/components/UIResource';

import styles from './TenderPortDetails.module.scss';

type TTenderPortDetailsProps = {
  className?: string;
  learnMoreLink?: {
    href: string;
    text: string;
  };
  tenderDetails?: string;
};

const TenderPortDetails = ({ className, learnMoreLink, tenderDetails }: TTenderPortDetailsProps) => {
  if (!tenderDetails) {
    return null;
  }

  return (
    <div className={classNames(styles.tenderDetails, className)}>
      <p className={styles.tenderMessage}>
        <UIResource id="Precheckout.tenderPort.requiresTenderBoat" />
      </p>
      {learnMoreLink?.href && (
        <Link
          className={styles.tenderLearnMore}
          href={learnMoreLink.href}
          prefetch={false}
          rel="noopener noreferrer"
          target="_blank"
        >
          {learnMoreLink.text || 'Learn More'}
        </Link>
      )}
    </div>
  );
};

export default TenderPortDetails;
